<template>
  <div>
    <Title title="Inicio"
           subtitle="Bienvenido/a"/>
    <el-carousel :interval="6000"
                 arrow="always"
                 height="500px">
      <el-carousel-item v-for="item in images" :key="item.icon.toString()" >
        <img :src="item.icon">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';

export default {
  name: 'Home',
  components: {
    Title,
  },
  data() {
    return {
      images: [
        // eslint-disable-next-line
        { icon: require('@/assets/img/GEOIMG.jpg') },
        // eslint-disable-next-line
        { icon: require('@/assets/img/3PILOT.jpg') },
        // eslint-disable-next-line
        { icon: require('@/assets/img/4PILOT.jpg') },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .el-carousel {
    text-align: center;
    z-index: 0 !important;
    .el-carousel__item {
      font-size: 18px;
      line-height: 500px;
      img {
        height: auto;
        max-width: 90%;
      }
    }
  }
</style>
